<template>
  <el-popover placement="bottom" trigger="hover">
    <img
      slot="reference"
      src="@/assets/icons/info.svg"
      style="width: 12px; height: 12px; margin-left: 2px;"
    />
    <div class="c-6 f-12" style="max-width: 180px">
      <slot name="content"></slot>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'ZgInfo'
}
</script>
